import api from "shared/api";
import { User } from "shared/store/auth/types";
import { AxiosPromise } from "axios";

const prefix = "api/base";

export interface UserLoginStats extends User {
  last_login: Date;
  times_logged_in: number;
}

export interface LoginRequest {
  partial_token: string;
}

export interface WallpaperInfo {
  image_url: string;
  name: string;
  referral_url: string;
  unsplash_url: string;
}

export interface Link {
  link: string;
}

export const postRequestMagicLink = async (
  email_address: string
): Promise<LoginRequest> => {
  const res = await api().post(`${prefix}/auth/request-magic-link`, {
    email_address,
  });

  return res.data;
};

export const postProcessMagicLink = (token: string): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/process-magic-link`, { token });
};

export const postLoggedOut = (): AxiosPromise<void> => {
  return api().post(`${prefix}/auth/logout`);
};

export const getUserLoginStats = async (): Promise<UserLoginStats[]> => {
  const res = await api().get<UserLoginStats[]>(`${prefix}/auth/stats`);
  return res.data;
};

export const getImpersonateLink = async (userId: number): Promise<Link> => {
  const res = await api().get<Link>(`${prefix}/auth/impersonate/${userId}`);
  return res.data;
};

export const getWallpaper = async (
  orientation: string
): Promise<WallpaperInfo> => {
  const res = await api().get<WallpaperInfo>(
    `${prefix}/wallpaper/${orientation}`
  );
  return res.data;
};
